import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { MaxBrainUtils } from 'app/projects/core/src/lib/utils';
import { EntityState } from 'app/projects/entity/src/lib/models/entity.state';
import {
    FetchPerformanceProfilePersonalReview,
    FetchPerformanceProfilePersonalReviewFailure,
    FetchPerformanceProfilePersonalReviewSuccess,
    SetPerformanceProfilePersonalReview,
    UnsetPerformanceProfilePersonalReview,
    UpdatePerformanceProfilePersonalReview,
    UpdatePerformanceProfilePersonalReviewFailure,
    UpdatePerformanceProfilePersonalReviewSuccess,
} from '../actions';
import { AddPerformanceProfilePersonalReviews } from '../actions/add-entities.action';
import { PerformanceProfilePersonalReviewApiService } from '../services/performance-profile-personal-review.api-service';
import { PerformanceProfilePersonalReview } from './performance-profile-personal-review.model';
import { PerformanceProfilePersonalReviewStateModel } from './performance-profile-personal-review.state-model';

@State<PerformanceProfilePersonalReviewStateModel>({
    name: 'performanceProfilePersonalReview',
    defaults: new PerformanceProfilePersonalReviewStateModel(),
})
@Injectable()
export class PerformanceProfilePersonalReviewState extends EntityState<PerformanceProfilePersonalReview> {
    static sortProperties: string[] = ['name'];

    @Selector()
    static getEntity(state: PerformanceProfilePersonalReviewStateModel, id: string = state.item): PerformanceProfilePersonalReview {
        if (!state.map) {
            return null;
        }

        return state.map.get(id) || null;
    }

    @Selector()
    static getEntities(state: PerformanceProfilePersonalReviewStateModel): PerformanceProfilePersonalReview[] {
        if (!state.map) {
            return null;
        }

        const toReturn = Array.from(state.map.values());

        toReturn.sort(MaxBrainUtils.sortCompareFn(PerformanceProfilePersonalReviewState.sortProperties));

        return toReturn;
    }

    constructor(private _performanceProfilePersonalReviewApiService: PerformanceProfilePersonalReviewApiService) {
        super(_performanceProfilePersonalReviewApiService, 0);
    }

    @Action(AddPerformanceProfilePersonalReviews)
    addPendingEntities(ctx: StateContext<PerformanceProfilePersonalReviewStateModel>, action: AddPerformanceProfilePersonalReviews): void {
        this._addEntities(ctx, action);
    }

    @Action(SetPerformanceProfilePersonalReview)
    setEntity(ctx: StateContext<PerformanceProfilePersonalReviewStateModel>, action: SetPerformanceProfilePersonalReview): void {
        this._setEntity(ctx, action, AddPerformanceProfilePersonalReviews);
    }

    @Action(UnsetPerformanceProfilePersonalReview)
    unsetEntity(ctx: StateContext<PerformanceProfilePersonalReviewStateModel>): void {
        this._unsetEntity(ctx);
    }

    @Action(UpdatePerformanceProfilePersonalReview)
    updateEntity(ctx: StateContext<PerformanceProfilePersonalReviewStateModel>, action: UpdatePerformanceProfilePersonalReview): void {
        this._performanceProfilePersonalReviewApiService.update(action.payload.review, action.payload.teamReviewId).subscribe(
            (entity) => {
                ctx.dispatch([new UpdatePerformanceProfilePersonalReviewSuccess(entity), new AddPerformanceProfilePersonalReviews([entity])]);
            },
            () => {
                ctx.dispatch(new UpdatePerformanceProfilePersonalReviewFailure());
            }
        );
    }

    @Action(FetchPerformanceProfilePersonalReview)
    fetchEntity(ctx: StateContext<PerformanceProfilePersonalReviewStateModel>, action: FetchPerformanceProfilePersonalReview): void {
        this._fetchEntity(
            ctx,
            action,
            FetchPerformanceProfilePersonalReviewSuccess,
            FetchPerformanceProfilePersonalReviewFailure,
            AddPerformanceProfilePersonalReviews,
            SetPerformanceProfilePersonalReview
        );
    }

    @Action(FetchPerformanceProfilePersonalReviewSuccess)
    fetchEntitySuccess(ctx: StateContext<PerformanceProfilePersonalReviewStateModel>, action: FetchPerformanceProfilePersonalReviewSuccess): void {
        this._fetchEntitySuccess(ctx, action);
    }

    @Action(FetchPerformanceProfilePersonalReviewFailure)
    fetchEntityFailure(ctx: StateContext<PerformanceProfilePersonalReviewStateModel>, action: FetchPerformanceProfilePersonalReviewFailure): void {
        this._fetchEntityFailure(ctx, action);
    }
}
